import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, Text, Button, VStack, useColorModeValue, Heading, HStack } from '@chakra-ui/react';
import EquipmentContent from './EquipmentContent';
import { getUserDetail } from '../services/api';

const AdminUserDetail = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { userId } = useParams();
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const userData = await getUserDetail(userId);
        setUser(userData);
      } catch (error) {
        console.error('Error fetching user data:', error);
        setError('ユーザー情報の取得に失敗しました');
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [userId, currentUser]);

  if (loading) return <Text>読み込み中...</Text>;
  if (error) return <Text color="red.500">{error}</Text>;
  if (!user) return <Text>ユーザーが見つかりません</Text>;

  const displayName = user.name ? `${user.name} 様邸` : `${user.email} 様邸`;

  return (
    <Box>
      <HStack
        spacing={4}
        align="stretch"
        bg={bgColor}
        borderColor={borderColor}
        borderWidth={1}
        borderRadius="md"
        p={4}
        mb={4}
      >
        <Button
          variant="outline"
          onClick={() => navigate('/admin/users')}
          alignSelf="flex-start"
        >
          ←顧客一覧
        </Button>
        <Text fontSize="xl" fontWeight="bold">
          {displayName}
        </Text>
      </HStack>

      <EquipmentContent targetUserId={userId} />
    </Box>
  );
};

export default AdminUserDetail; 